<template>
  <div>
    <v-row>
      <v-col>
        <v-dialog v-model="dialog" persistent max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline"> Create New Sender</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Email*"
                      v-model="email"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Name*"
                      v-model="name"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      aria-autocomplete="off"
                      label="Label*"
                      v-model="label"
                      required
                    ></v-text-field>
                  </v-col>
                  
                  <v-col cols="12" v-if="errorMessage">
                    <h3 class="text-center red--text">{{ errorMessage }}</h3>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close()">Close</v-btn>
              <v-btn color="blue darken-1" text @click="saveSender"
                >Save</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <loading-overlay v-if="loading"/>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Swal from "sweetalert2";
import LoadingOverlay from "../common/LoadingOverlay.vue";

export default {
  name: "DocumentTypeModal",
  props: {
    dialog: Boolean,
    documentTypeUpdate: Object,
    senderData: String
  },
  components: {
    LoadingOverlay
  },
  data() {
    return {
      errorMessage: "",
      loading: false,
      name: "",
      label: "",
      email: "",
    };
  },
  methods: {
    ...mapActions(["createSender"]),
    close() {
      this.name = "";
      this.label = "";
      this.email = "";
      this.$emit("closeDialog", false);
    },
    validateEmail(email){
      if(email)
      return email.match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
      else
      return false
    },
    validateData(){
      if(this.email == ""){
        this.errorMessage = "Email must not be empty"
        return
      }
      if(this.name == ""){
        this.errorMessage = "Name must not be empty"
        return
      }
      if(this.label == ""){
        this.errorMessage = "Label must not be empty"
        return
      }
      if(this.email && this.name && this.label) {
        this.errorMessage = ""
        return
      }
    },
    async saveSender() {
      this.validateData()
      if(this.errorMessage){
        return
      }
      let res = this.validateEmail(this.email)
      if(res == null){
        this.errorMessage = "Email must be a valid email"
        return
      }
      this.loading = true;
      let body = {
        name: this.name,
        email: this.email,
        label: this.label,
      };
      let save;
      save = await this.createSender(body);
      if (save.error) {
        this.loading = false
        if (save.status == 400) this.errorMessage = save.message;
        else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Internal Server Error",
          });
        }
      } else if (save) {
        this.loading = false
        this.name = "";
        this.label = "";
        this.email = "";
        this.$emit("closeDialog", true);
      }
    },
  },
  watch: { 
    dialog: {
      handler() {
        if(this.validateEmail(this.senderData))
          this.email = this.senderData
        else
          this.label = this.senderData
      },
    },
  }
};
</script>

<style>
</style>